<!-- Start Sidemenu Area -->
<div class="sidemenu-area">
    <div class="sidemenu-header">
        <a href="/dashboard/analytics" class="navbar-brand d-flex align-items-center">
            <!-- <img src="assets/img/logo-servicios-gt.svg" alt="image" width="40em" class="bg-logo"> -->
            <app-logo-color [height]="'2.65em'" [class.mr-name]="logoSrc==1" />
            <span class="name-brand" *ngIf="logoSrc==1">Servicios-gt</span>
            <span class="name-brand" *ngIf="logoSrc==2">xtracciones</span>
            <span class="name-brand" *ngIf="logoSrc==3">AyO</span>
            <span class="name-brand" *ngIf="logoSrc==4">AYA</span>
        </a>

        <div class="burger-menu d-none d-lg-block">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>

        <div class="responsive-burger-menu d-block d-lg-none">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
    </div>

    <div class="sidemenu-body">
        <ul class="sidemenu-nav metisMenu h-100" id="sidemenu-nav" data-simplebar>
            <li class="nav-item-title" *ngIf="view == viewType.NORMAL">
                Dashboards
            </li>
            <li class="nav-item" *ngIf="view == viewType.NORMAL" routerLinkActive="active mm-active">
                <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                    <span class="icon"><i class='fa-solid fa-chart-pie'></i></span>
                    <span class="menu-title">Dashboards</span>
                    <!-- <span class="badge">3</span> -->
                </a>
                <ul class="sidemenu-nav-second-level">
                    <!-- <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/dashboard/analytics-custom" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa-solid fa-chart-pie"></i>
                                    <i style="color: gold;" class="fa-solid fa-star superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Facturas de Cliente</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5024]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/dashboard/analytics" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-chart-pie"></i></span>
                            <span class="menu-title">Facturas de Proveedor</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5024]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/dashboard/analytics-expense" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-chart-pie"></i></span>
                            <span class="menu-title">Gastos</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5025]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/reports/charts/budget" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-arrow-trend-up"></i></span>
                            <span class="menu-title">Presupuesto</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5026]"
                        [permissionType]="permissionType.ALL">
                        <a class="nav-link">
                            <span class="icon"><i class="fa-solid fa-chart-pie"></i></span>
                            <span class="menu-title">Resultados</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5027]"
                        [permissionType]="permissionType.ALL">
                        <a class="nav-link">
                            <span class="icon"><i class="fa-solid fa-scale-balanced"></i></span>
                            <span class="menu-title">Balance</span>
                        </a>
                    </li> -->
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5024]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/dashboard/analytics-sales" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa-solid fa-receipt"></i>
                                    <i style="color: gold;" class="fa-solid fa-chart-pie superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Ventas</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5025]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/dashboard/analytics-purchases" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa-solid fa-dolly"></i>
                                    <i style="color: gold;" class="fa-solid fa-chart-pie superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Compras</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5026]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/dashboard/analytics-cxc" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa-solid fa-coins"></i>
                                    <i style="color: gold;" class="fa-solid fa-chart-pie superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">CxC</span>
                        </a>
                    </li>
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5027]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/dashboard/analytics-cxp" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa-solid fa-money-bill-wave"></i>
                                    <i style="color: gold;" class="fa-solid fa-chart-pie superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">CxP</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li class="nav-item-title" *ngIf="view == viewType.NORMAL">
                Main
            </li>
            <li class="nav-item" *ngIf="view == viewType.NORMAL" routerLinkActive="active mm-active"
                [appCheckPermission]="[2000,2046,2043,2049,5020,5021,5022, 5031, 5032, 5015, 5022, 5055, 5056, 5057, 5058, 5059,
                    5065,5066,5067,5068,5069,5070,5071,5072,5073,5074,5075,5076,5086
                ]" [permissionType]="permissionType.ALL">
                <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                    <span class="icon"><i class='bx bxs-shopping-bag'></i></span>
                    <span class="menu-title">Operación</span>
                    <!-- <span class="badge">3</span> -->
                </a>

                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[2000, 2046, 2042,2043, 2049,5065,5066,5067,5028,5020,5043,5044,5022,5076]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-boxes'></i>
                                </span>
                            </span>
                            <span class="menu-title">Inventario</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li id="facturaDeVenta" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000,2046]" [permissionType]="permissionType.ALL">
                                <a routerLink="/sales/invoice" class="nav-link">
                                    <span class="icon"><i class='fa fa-receipt'></i></span>
                                    <span class="menu-title">Factura de Venta</span>
                                </a>
                            </li>
                            <li id="facturaDeVenta" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000,5086]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/billr-downnote" class="nav-link">
                                    <span class="icon"><i class='fa fa-file-pen'></i></span>
                                    <span class="menu-title">Nota de Crédito</span>
                                </a>
                            </li>
                            <li id="facturaDeCompra" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 2042]" [permissionType]="permissionType.ALL">
                                <a routerLink="/purchases/invoice" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-dolly"></i></span>
                                    <span class="menu-title">Factura de Compra</span>
                                </a>
                            </li>
                            <li id="transferirTransformar" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 2043, 2049]" [permissionType]="permissionType.ALL">
                                <a routerLink="/products/transfer" class="nav-link">
                                    <span class="icon">
                                        <i class="fa-solid fa-share-from-square"></i>
                                    </span>
                                    <span class="menu-title">
                                        <span [appCheckPermission]="[2043]"
                                            [permissionType]="permissionType.ALL">Transferir
                                            <span [appCheckPermission]="[2049]" [permissionType]="permissionType.ALL">
                                                /
                                            </span>
                                        </span>
                                        <span [appCheckPermission]="[2049]"
                                            [permissionType]="permissionType.ALL">Transformar</span>
                                    </span>
                                </a>
                            </li>
                            <li id="productPosibleTransformation" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5096]" [permissionType]="permissionType.ALL">
                                <a routerLink="/products/posible-transformation" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-boxes-stacked"></i></span>
                                    <span class="menu-title">Productos A Transformar</span>
                                </a>
                            </li>
                            <li id="ordenCompra" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5065]" [permissionType]="permissionType.ALL">
                                <a routerLink="/orders/purchases" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-cart-shopping"></i></span>
                                    <span class="menu-title">Órdenes de Compra</span>
                                </a>
                            </li>
                            <li id="asociarOrdenesCompras" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5066]" [permissionType]="permissionType.ALL">
                                <a routerLink="/orders/associationmenu" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-folder-tree"></i></span>
                                    <span class="menu-title">Asociar Órdenes/Compras</span>
                                </a>
                            </li>
                            <li id="recibirOrdern" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5067]" [permissionType]="permissionType.ALL">
                                <a routerLink="/orders/received" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-box-open"></i></span>
                                    <span class="menu-title">Recibir Orden</span>
                                </a>
                            </li>
                            <li id="listaDePedidos" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5028]" [permissionType]="permissionType.ALL">
                                <a routerLink="/orders/list" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-paper-plane"></i></span>
                                    <span class="menu-title">Lista de Pedidos</span>
                                </a>
                            </li>
                            <li id="listaDePrecios" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5020]" [permissionType]="permissionType.ALL">
                                <a routerLink="/sales/pricelist" class="nav-link">
                                    <span class="icon"><i class='fa fa-tags'></i></span>
                                    <span class="menu-title">Lista/Asignación de Precios</span>
                                </a>
                            </li>
                            <li id="inventarioAleatorio" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[5043]" [permissionType]="permissionType.CREATE">
                                <a routerLink="/dashboard/count-inventory" class="nav-link">
                                    <span class="icon"><i class='fa fa-boxes'></i></span>
                                    <span class="menu-title">Inventario Aleatorio</span>
                                </a>
                            </li>
                            <li id="inventarioAleatorio" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[5044]" [permissionType]="permissionType.CREATE">
                                <a routerLink="/dashboard/make-inventory" class="nav-link">
                                    <span class="icon"><i class='fa fa-file-signature'></i></span>
                                    <span class="menu-title">Realizar Inventario</span>
                                </a>
                            </li>
                            <li id="recurrencia" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5022]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/recurrence" class="nav-link">
                                    <span class="icon"><i class='fa-solid fa-calendar-days'></i></span>
                                    <span class="menu-title">Recurrencia</span>
                                </a>
                            </li>
                            <li id="warehouse-operator-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5076]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/warehouse-operator" class="nav-link">
                                    <span class="icon"><i class='fas fa-warehouse'></i></span>
                                    <span class="menu-title">Ubicación / Destino / Bodega</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>


                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[2000,5068,5069,5070,5071,5073,5075,5068,5069]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-cubes'></i>
                                </span>
                            </span>
                            <span class="menu-title">Producción</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li id="entryNotes" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5068]" [permissionType]="permissionType.ALL">
                                <a routerLink="/notes/entry-notes" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-note-sticky"></i></span>
                                    <span class="menu-title">Notas de Ingreso</span>
                                </a>
                            </li>
                            <li id="associatedEntryNotes" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5069]" [permissionType]="permissionType.ALL">
                                <a routerLink="/notes/association-entry-notes" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-diagram-project"></i></span>
                                    <span class="menu-title">Asociar Notas de Ingreso</span>
                                </a>
                            </li>
                            <li id="coas" class="nav-item" routerLinkActive="active" [appCheckPermission]="[2000, 5070]"
                                [permissionType]="permissionType.ALL">
                                <a routerLink="/coas/certificates-of-analysis" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-list-alt"></i></span>
                                    <span class="menu-title">Certificado de Calidad (COA)</span>
                                </a>
                            </li>
                            <li id="scaleNotes" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5071]" [permissionType]="permissionType.ALL">
                                <a routerLink="/notes/scale-notes" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-note-sticky"></i></span>
                                    <span class="menu-title">Boleta de Báscula</span>
                                </a>
                            </li>
                            <li id="recipe-diagram-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5073]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/recipes-diagram" class="nav-link">
                                    <span class="icon"><i class='fas fa-diagram-predecessor'></i></span>
                                    <span class="menu-title">Diagrama Recetas</span>
                                </a>
                            </li>
                            <li id="execution-productive-process-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5075]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/execution-productive-process" class="nav-link">
                                    <span class="icon"><i class='fas fa-flask-vial'></i></span>
                                    <span class="menu-title">Ejecución de Procesos Productivos</span>
                                </a>
                            </li>
                            <li id="entryNotes" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5068]" [permissionType]="permissionType.ALL">
                                <a routerLink="/notes/exit-notes" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-file-export"></i></span>
                                    <span class="menu-title">Notas de Salida</span>
                                </a>
                            </li>

                            <li id="associatedEntryNotes" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5069]" [permissionType]="permissionType.ALL">
                                <a routerLink="/notes/association-exit-notes" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-handshake"></i></span>
                                    <span class="menu-title">Asociar Notas de Salida</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[2000,5015,5016,5056,5062, 5087, 5091]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-piggy-bank'></i>
                                </span>
                            </span>
                            <span class="menu-title">Cajas y Bancos</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li id="cierreDeCaja" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[5015]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/cash-and-accounts" class="nav-link">
                                    <span class="icon"><i class='bx bx-calculator'></i></span>
                                    <span class="menu-title">Cierre de Caja</span>
                                </a>
                            </li>
                            <li id="trasladoCajaABancos" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[5016]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/transfer-banks-cash" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-money-bill-transfer"></i></span>
                                    <span class="menu-title">Traslados Caja ⇄ Banco</span>
                                </a>
                            </li>
                            <li id="banking-serp" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5056]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/banking" class="nav-link">
                                    <span class="icon"><i class='fas fa-bank'></i></span>
                                    <span class="menu-title">Bancarización</span>
                                </a>
                            </li>
                            <li id="ppe-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5062]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/bi-transfer" class="nav-link">
                                    <span class="icon"><i class='fas fa-money-bill-transfer'></i></span>
                                    <span class="menu-title">Transferencias BI</span>
                                </a>
                            </li>
                            <li id="ppe-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5091]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/bam-transfer" class="nav-link">
                                    <span class="icon"><i class='fas fa-landmark'></i></span>
                                    <span class="menu-title">Transferencias BAM</span>
                                </a>
                            </li>
                            <li id="ppe-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5087]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/deposit-config" class="nav-link">
                                    <span class="icon"><i class='fas fa-tasks'></i></span>
                                    <span class="menu-title">Revisar Solicitudes Depósitos</span>
                                </a>
                            </li>
                            <li id="ppe-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5085]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/deposit-request" class="nav-link">
                                    <span class="icon"><i class='fas fa-paper-plane'></i></span>
                                    <span class="menu-title">Solicitud de Depósito</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[2000, 5015,5057,5058]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-hand-holding-dollar'></i>
                                </span>
                            </span>
                            <span class="menu-title">Cuentas por Cobrar y Pagar</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li id="cuentasPorCobrar" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[5015]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/acc-receivable" class="nav-link">
                                    <span class="icon"><i class='bx bx-calculator'></i></span>
                                    <span class="menu-title">Cuentas por Cobrar</span>
                                </a>
                            </li>
                            <li id="billp-uppay" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5057]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/billp-uppay" class="nav-link">
                                    <span class="icon"><i class='fas fa-money-bill-wave'></i></span>
                                    <span class="menu-title">Pago CxP</span>
                                </a>
                            </li>
                            <li id="billr-downpay" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5058]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/billr-downpay" class="nav-link">
                                    <span class="icon"><i class='fas fa-coins'></i></span>
                                    <span class="menu-title">Pago CxC</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[2000, 5031,5031,5032,5059]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-coins'></i>
                                </span>
                            </span>
                            <span class="menu-title">Gastos</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li id="Planillas" class="nav-item" routerLinkActive="active" [appCheckPermission]="[5031]"
                                [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/payroll" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-money-check-dollar"></i></span>
                                    <span class="menu-title">Planillas</span>
                                </a>
                            </li>
                            <li id="Planillas" class="nav-item" routerLinkActive="active" [appCheckPermission]="[5031]"
                                [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/rrhh-payroll" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-money-check-dollar"></i></span>
                                    <span class="menu-title">Planillas Mensuales</span>
                                </a>
                            </li>
                            <li id="Pagos Extras" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[5032]" [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/extra-payment" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-money-check"></i></span>
                                    <span class="menu-title">Pagos extra</span>
                                </a>
                            </li>
                            <li id="expense-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5059]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/expense-submit" class="nav-link">
                                    <span class="icon"><i class='fas fa-stamp'></i></span>
                                    <span class="menu-title">Ingreso de Gastos</span>
                                </a>
                            </li>
                            <li id="Pagos Extras" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[5032]" [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/employees-suspensions" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-user-group"></i></span>
                                    <span class="menu-title">Suspensiones</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[2000, 5060]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-layer-group'></i>
                                </span>
                            </span>
                            <span class="menu-title">PPE</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li id="ppe-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5060]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/ppe-submit" class="nav-link">
                                    <span class="icon"><i class='fas fa-toolbox'></i></span>
                                    <span class="menu-title">PPE Registro</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[2000, 5055,5072,5074, 5084]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-user-tie'></i>
                                </span>
                            </span>
                            <span class="menu-title">Administrativo</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li id="facturaDeVenta" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5055]" [permissionType]="permissionType.ALL">
                                <a routerLink="/sales/token" class="nav-link">
                                    <span class="icon"><i class='fa fa-fingerprint'></i></span>
                                    <span class="menu-title">Token</span>
                                </a>
                            </li>
                            <li id="prospecto" class="nav-item" routerLinkActive="active">
                                <a routerLink="/company-application" class="nav-link">
                                    <span class="icon"><i class='fa-solid fa-file'></i></span>
                                    <span class="menu-title">Prospecto de Venta</span>
                                </a>
                            </li>
                            <li id="ppe-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5072]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/geographic-map" class="nav-link">
                                    <span class="icon"><i class='fas fa-map-marked-alt'></i></span>
                                    <span class="menu-title">Mapa Geográfico</span>
                                </a>
                            </li>

                            <li id="view-warehouse-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5074]" [permissionType]="permissionType.ALL">
                                <a routerLink="/dashboard/view-warehouses" class="nav-link">
                                    <span class="icon"><i class='fas fa-warehouse'></i></span>
                                    <span class="menu-title">Bodega 3D</span>
                                </a>
                            </li>

                            <li id="employee-list-submit" class="nav-item" routerLinkActive="active"
                                [appCheckPermission]="[2000, 5084]" [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/employees-list" class="nav-link">
                                    <span class="icon"><i class='fas fa-users-rectangle'></i></span>
                                    <span class="menu-title">Empleados</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
            <li class="nav-item" *ngIf="view == viewType.NORMAL" routerLinkActive="active mm-active" id="reports"
                [appCheckPermission]="[5000,5001,5002,5003,5004,5005,5006,2130,2131,2132,2133,2134,2135,2136,2137,2138,2139,5077,5092]"
                [permissionType]="permissionType.ALL">
                <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                    <span class="icon"><i class='fa fa-clipboard'></i></span>
                    <span class="menu-title">Reportes</span>
                    <!-- <span class="badge">6</span> -->
                </a>

                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5001]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/inventory" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-boxes'></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Inventarios</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5002]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/banks" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-bank"></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Bancos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5003]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/account-receivable" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa fa-thumbs-up"></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Cuentas por Cobrar</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5004]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/account-payable" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa fa-thumbs-down"></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Cuentas por Pagar</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5005]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/spending" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa fa-coins"></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Gastos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level"
                    [appCheckPermission]="[5000,5006,2130,2131,2132,2133,2134,2135,2136,2137,2138,2139]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/accounting" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa fa-chart-column"></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Contabilidad</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000, 5042]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/graphs" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa fa-table-cells"></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Graficas</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000, 5063]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/dynamic" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fa fa-magnifying-glass-chart"></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Reportes Dinámicos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5077]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/maye" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-drumstick-bite'></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Reportes MAYE</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5077]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/extractions" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-flask'></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Reportes Extracciones</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5000,5092,5093]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/reports/rrhh" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-people-roof'></i>
                                    <i class="fa fa-clipboard superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Reportes Recursos Humanos</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li class="nav-item" routerLinkActive="active mm-active" id="settings" [appCheckPermission]="[7000,7001,7002,7003,7004,7005,7006,7007,5007,5008,5009,5010,5011,5021, 5012, 5013, 5029, 5030, 5064, 7008, 5065,5078,
                    5079, 5080, 5081
                ]" [permissionType]="permissionType.ALL">
                <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                    <span class="icon"><i class='fa fa-gear'></i></span>
                    <span class="menu-title">Configuración General</span>
                    <!-- <span class="badge">4</span> -->
                </a>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5008]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-boxes'></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Inventarios</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/inventory/categories" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-object-group'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Familias</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/inventory/products" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-box'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Productos</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/inventory/products-favorites" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-star'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Productos Favoritos</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/inventory/warehouses" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-warehouse'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Bodegas</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/inventory/vendors" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class="fa fa-people-carry-box"></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Clientes/Proveedores</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/edit-invoice" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='bx bxs-file'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Editar formato facturas</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/sales/profit" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-tag'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Margen de Utilidad</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/inventory/price-by-location" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-tag'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Precio por Ubicación</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/sales/recipes" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-list-numeric'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Recetas</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5035]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-user-group'></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Afiliados</span>
                            <!-- <span class="badge">1</span> -->
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/affiliates/convert" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-id-card'></i>
                                            <i class="fa fa-user-group superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Convertir</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/affiliates/admin" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-sliders'></i>
                                            <i class="fa fa-user-group superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Administración</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5009]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fas fa-bank'></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Bancos</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/bank/accounts" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-vault'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Cuentas Bancarias</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/bank/cashiers" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-cash-register'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Cajas</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5078]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-certificate'></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">COAS/Productos</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/coas/parameter" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-list-alt'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Parámetros COA</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/coas/parameter-products" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-list-1-2'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Parámetros de Productos</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active">
                                <a routerLink="/configuration/coas/products-cp" class="nav-link">
                                    <span class="icon">
                                        <span class="superposition-container">
                                            <i class='fa fa-list'></i>
                                            <i class="fa-solid fa-gear superposition-element"></i>
                                        </span>
                                    </span>
                                    <span class="menu-title">Productos <i class="fa-solid fa-arrow-right"></i>
                                        C/P</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5010]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/roles-and-permissions" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-users-viewfinder"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Roles y permisos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5011]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/user-role" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-user"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Usuarios y roles</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7001]" [permissionType]="permissionType.ALL" notPartner>
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/inpartner" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-handshake"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Partner</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7001]" [permissionType]="permissionType.ALL" notPartner>
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/delete-duplicates" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-file-invoice"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Eliminar Duplicados</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7003]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/banking" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-bank"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Bancarización</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7003]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/automatic-withholdings" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-balance-scale"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Retenciones automáticas</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7002]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/upload-dte" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-upload"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Carga DTE</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7005]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/tax-form-list" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-file-lines"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Declaraciones SAT</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7006]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/password-business" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-key"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Password SAT</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7009]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/fiscal-documents-count" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-calculator"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Contador de Documentos Fiscales</span>
                        </a>
                    </li>
                </ul>
                <!-- <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7004]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/user-permissions" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-user"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Permisos de Usuario</span>
                        </a>
                    </li>
                </ul> -->
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN" notPartner>
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/date-dte" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-calendar-alt"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Fechas DTE</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7007]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/information-inadmin" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-info-circle"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Informacion</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.INADMIN"
                    [appCheckPermission]="[7000, 7008]" [permissionType]="permissionType.ALL" notPartner>
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/in-admin/administrative-companies" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-city"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Empresas Administrativas</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5048]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/general" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-gears"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">General</span>
                        </a>
                    </li>
                </ul>
                <ul id="rrhh" class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5012, 5013, 5029, 5030]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active mm-active">
                        <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-person'></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">RRHH</span>
                        </a>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5007, 5012, 5013]"
                                [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/organization" class="nav-link">
                                    <span class="icon"><i class='fa fa-sitemap'></i></span>
                                    <span class="menu-title">Organigrama</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5007, 5012, 5029]"
                                [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/jobs" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-address-card"></i></span>
                                    <span class="menu-title">Puestos</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="sidemenu-nav-third-level">
                            <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5007, 5012, 5030]"
                                [permissionType]="permissionType.ALL">
                                <a routerLink="/human-resources/register" class="nav-link">
                                    <span class="icon"><i class="fa-solid fa-user-plus"></i></span>
                                    <span class="menu-title">Contratación</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL">
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5007, 5021]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/dashboard/budget" class="nav-link">
                            <span class="icon"><i class='fa fa-chart-line'></i></span>
                            <span class="menu-title">Presupuestos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5050]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/dashboard/nomenclature" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-rectangle-list"></i></span>
                            <span class="menu-title">Nomenclatura</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5051]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/expense-category" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-layer-group"></i></span>
                            <span class="menu-title">Categorías Registradas</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5052]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/load-csv" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-layer-group"></i></span>
                            <span class="menu-title">Carga de CSV</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5064]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/administrative-warehouse" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-dolly"></i></span>
                            <span class="menu-title">Bodegas Administrativas</span>
                        </a>
                    </li>
                </ul>
                <!-- <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5064]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/administrative-sale-purchase" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-dolly"></i></span>
                            <span class="menu-title">Ruta Compra/Venta Administrativa</span>
                        </a>
                    </li>
                </ul> -->
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5079]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/particularity-invoice-routing" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-receipt"></i></span>
                            <span class="menu-title">Configuracion Factura Administrativa</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5099]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/product-routing-purchases" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-diagram-predecessor"></i></span>
                            <span class="menu-title">Configuración Productos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5097]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/product-conversion" class="nav-link">
                            <span class="icon"><i class="fa-solid fa-diagram-project"></i></span>
                            <span class="menu-title">Configuración Productos A Tranformar</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL" [appCheckPermission]="[5080]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/production-processes" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-tasks"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Proceso Productivo</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL"
                    [appCheckPermission]="[5007, 5081]" [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/configuration/destinations" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class="fas fa-location"></i>
                                    <i class="fa-solid fa-gear superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Destinos</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li class="nav-item" *ngIf="view == viewType.NORMAL" routerLinkActive="active mm-active"
                [appCheckPermission]="[5047,5017,5018,5019,5023,5036,5037,5038,5039,5082,5083]"
                [permissionType]="permissionType.ALL">
                <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                    <span class="icon"><i class="fa-solid fa-clock-rotate-left"></i></span>
                    <span class="menu-title">Historiales</span>
                    <!-- <span class="badge">1</span> -->
                </a>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5047,5017,5023,5018,5038,5039]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/historical/operations" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-building'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Operaciones</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5037]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/historical/orders" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa-solid fa-paper-plane'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Pedidos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5082]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/historical/order-reservation" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa-solid fa-scroll'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Pedidos Venta</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5083]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/historical/productions-process" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa-solid fa-list-1-2'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Procesos Productivos</span>
                        </a>
                    </li>
                </ul>
                <!-- <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5047,5017,5023,5018,5038,5039]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/historical/purchases-pending-receipt" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-building'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Compras Pendientes de Recibir</span>
                        </a>
                    </li>
                </ul> -->
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5036]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/historical/recurrence" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa-solid fa-calendar-days'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Recurrencias</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level">
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5019]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/historical/closures" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-cash-register'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Cierres de Caja</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level">
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5088]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/historical/destination-closures" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-file-contract'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Cierres de Caja Por Destino</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level">
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5019]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/historical/rrhh" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-users'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Histórico de Recursos Humanos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" *ngIf="view == viewType.NORMAL">
                    <li class="nav-item" routerLinkActive="active" [appCheckPermission]="[5007, 5049]"
                        [permissionType]="permissionType.ALL">
                        <a routerLink="/configuration/accounting-tax-forms" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa fa-chart-line'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">Cierres y Declaraciones de Impuestos</span>
                        </a>
                    </li>
                </ul>
                <ul class="sidemenu-nav-second-level" [appCheckPermission]="[5061]"
                    [permissionType]="permissionType.ALL">
                    <li class="nav-item" routerLinkActive="active">
                        <a routerLink="/historical/ppe" class="nav-link">
                            <span class="icon">
                                <span class="superposition-container">
                                    <i class='fa-solid fa-toolbox'></i>
                                    <i class="fa-solid fa-clock-rotate-left superposition-element"></i>
                                </span>
                            </span>
                            <span class="menu-title">PPE</span>
                        </a>
                    </li>
                </ul>
            </li>
            <ng-container *ngIf="showElement">
                <li class="nav-item-title">
                    Apps
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-envelope'></i></span>
                        <span class="menu-title">Email</span>
                        <span class="badge">3</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/app-email/inbox" class="nav-link">
                                <span class="icon"><i class='bx bxs-inbox'></i></span>
                                <span class="menu-title">Inbox</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/app-email/read" class="nav-link">
                                <span class="icon"><i class='bx bxs-badge-check'></i></span>
                                <span class="menu-title">Read</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/app-email/compose" class="nav-link">
                                <span class="icon"><i class='bx bx-send'></i></span>
                                <span class="menu-title">Compose</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/app-chat" class="nav-link">
                        <span class="icon"><i class='bx bx-message'></i></span>
                        <span class="menu-title">Chat</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/app-todo" class="nav-link">
                        <span class="icon"><i class='bx bx-badge-check'></i></span>
                        <span class="menu-title">Todo</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/app-calendar" class="nav-link">
                        <span class="icon"><i class='bx bx-calendar'></i></span>
                        <span class="menu-title">Calendar</span>
                    </a>
                </li>

                <li class="nav-item-title">
                    UI Elements
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/grid" class="nav-link">
                        <span class="icon"><i class='bx bx-grid-alt'></i></span>
                        <span class="menu-title">Grid</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/colors" class="nav-link">
                        <span class="icon"><i class='bx bxs-color-fill'></i></span>
                        <span class="menu-title">Colors</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-brightness'></i></span>
                        <span class="menu-title">Icons</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/icons/boxicons" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">BoxIcons</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/icons/feathericons" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Feather Icons</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-card'></i></span>
                        <span class="menu-title">Card</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/card/basic-card" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Basic Card</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/card/colors-card" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Colors Card</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/card/statistics-card" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Statistics Card</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-chart'></i></span>
                        <span class="menu-title">Component</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/alerts" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Alert</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/badges" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Badge</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/borders" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Border</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/breadcrumb" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Breadcrumb</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/buttons" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Buttons</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/buttons-group" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Button Group</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/slider" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Slider</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/collapse" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Collapse</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/display" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Display</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/dropdown" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Dropdown</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/embed" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Embed</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/figures" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Figures</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/images" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Images</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/jumbotron" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Jumbotron</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/list-group" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">List Group</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/media-object" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Media Object</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/modal" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Modal</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/navs" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Navs</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/navbar" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Navbar</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/pagination" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Pagination</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/progress" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Progress</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/spinner" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Spinner</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/text" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Text</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/vertical-alignment" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Vertical Alignment</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/typography" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Typography</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/tooltips" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Tooltips</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/ui-components/popovers" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Popovers</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item-title">
                    Forms & Table
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/forms/form-layout" class="nav-link">
                        <span class="icon"><i class='bx bxs-layer'></i></span>
                        <span class="menu-title">Form Layout</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/forms/form-input-group" class="nav-link">
                        <span class="icon"><i class='bx bx-file'></i></span>
                        <span class="menu-title">Form Input Group</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/table/table-light" class="nav-link">
                        <span class="icon"><i class='bx bx-table'></i></span>
                        <span class="menu-title">Table</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/table/table-dark" class="nav-link">
                        <span class="icon"><i class='bx bx-calendar'></i></span>
                        <span class="menu-title">Table Dark</span>
                    </a>
                </li>

                <li class="nav-item-title">
                    Pages
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/profile" class="nav-link">
                        <span class="icon"><i class='bx bx-user-circle'></i></span>
                        <span class="menu-title">Profile</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/faq" class="nav-link">
                        <span class="icon"><i class='bx bx-help-circle'></i></span>
                        <span class="menu-title">FAQ</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/invoice" class="nav-link">
                        <span class="icon"><i class='bx bx-receipt'></i></span>
                        <span class="menu-title">Invoice</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/gallery" class="nav-link">
                        <span class="icon"><i class='bx bx-images'></i></span>
                        <span class="menu-title">Gallery</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/timeline" class="nav-link">
                        <span class="icon"><i class='bx bx-align-justify'></i></span>
                        <span class="menu-title">Timeline</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/pricing" class="nav-link">
                        <span class="icon"><i class='bx bx-money'></i></span>
                        <span class="menu-title">Pricing</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/blank-page" class="nav-link">
                        <span class="icon"><i class='bx bx-file-blank'></i></span>
                        <span class="menu-title">Blank Page</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-lock-open'></i></span>
                        <span class="menu-title">Authentication</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/login" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-log-in'></i></span>
                                <span class="menu-title">Login v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/login-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bxs-log-in'></i></span>
                                <span class="menu-title">Login v2</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/register" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-log-in-circle'></i></span>
                                <span class="menu-title">Register v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/register-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bxs-log-in-circle'></i></span>
                                <span class="menu-title">Register v2</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/forgot-password" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-lock'></i></span>
                                <span class="menu-title">Forgot Password v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/forgot-password-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-lock-alt'></i></span>
                                <span class="menu-title">Forgot Password v2</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/reset-password" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-log-out'></i></span>
                                <span class="menu-title">Reset Password v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/reset-password-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-log-out-circle'></i></span>
                                <span class="menu-title">Reset Password v2</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/lock-screen" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bxs-lock-open-alt'></i></span>
                                <span class="menu-title">Lock Screen v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/authentication/lock-screen-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bxs-lock-open'></i></span>
                                <span class="menu-title">Lock Screen v2</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-share-alt'></i></span>
                        <span class="menu-title">Miscellaneous</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/miscellaneous/not-authorized" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-traffic-cone'></i></span>
                                <span class="menu-title">Not Authorized v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/miscellaneous/not-authorized-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bxs-traffic-cone'></i></span>
                                <span class="menu-title">Not Authorized v2</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/miscellaneous/maintenance" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-recycle'></i></span>
                                <span class="menu-title">Maintenance v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/miscellaneous/maintenance-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bx-recycle bx-rotate-90'></i></span>
                                <span class="menu-title">Maintenance v2</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/miscellaneous/coming-soon" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bxs-up-arrow'></i></span>
                                <span class="menu-title">Coming Soon v1</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/miscellaneous/coming-soon-with-image" target="_blank" class="nav-link">
                                <span class="icon"><i class='bx bxs-right-arrow'></i></span>
                                <span class="menu-title">Coming Soon v2</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                                <span class="icon"><i class='bx bx-share-alt'></i></span>
                                <span class="menu-title">Error</span>
                            </a>

                            <ul class="sidemenu-nav-third-level">
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/error/errorv1" target="_blank" class="nav-link">
                                        <span class="icon"><i class='bx bx-error'></i></span>
                                        <span class="menu-title">404 v1</span>
                                    </a>
                                </li>

                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/error/errorv2" target="_blank" class="nav-link">
                                        <span class="icon"><i class='bx bxs-error'></i></span>
                                        <span class="menu-title">404 v2</span>
                                    </a>
                                </li>

                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/error/errorv3" target="_blank" class="nav-link">
                                        <span class="icon"><i class='bx bx-error-circle'></i></span>
                                        <span class="menu-title">500 v1</span>
                                    </a>
                                </li>

                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/error/errorv4" target="_blank" class="nav-link">
                                        <span class="icon"><i class='bx bxs-error-circle'></i></span>
                                        <span class="menu-title">500 v2</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>

                <li class="nav-item-title">
                    Charts & Maps
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-chart'></i></span>
                        <span class="menu-title">Charts</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/apex-charts" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Apex Charts</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/chartjs" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Chartjs</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a routerLink="/maps" class="nav-link">
                        <span class="icon"><i class='bx bx-world'></i></span>
                        <span class="menu-title">Maps</span>
                    </a>
                </li>

                <li class="nav-item-title">
                    Others
                </li>

                <li class="nav-item">
                    <a href="#" class="collapsed-nav-link nav-link" aria-expanded="false">
                        <span class="icon"><i class='bx bx-menu'></i></span>
                        <span class="menu-title">Menu Levels</span>
                    </a>

                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item">
                            <a href="javascript:void(0)" class="nav-link">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">First Level</span>
                            </a>
                        </li>

                        <li class="nav-item">
                            <a href="javascript:void(0)" class="collapsed-nav-link nav-link" aria-expanded="false">
                                <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                <span class="menu-title">Second Level</span>
                            </a>

                            <ul class="sidemenu-nav-third-level">
                                <li class="nav-item">
                                    <a href="javascript:void(0)" class="nav-link">
                                        <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                        <span class="menu-title">Second Level 2.1</span>
                                    </a>
                                </li>

                                <li class="nav-item">
                                    <a href="javascript:void(0)" class="nav-link">
                                        <span class="icon"><i class='bx bx-right-arrow-alt'></i></span>
                                        <span class="menu-title">Second Level 2.2</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>

                <li class="nav-item">
                    <a href="javascript:void(0)" class="nav-link disabled">
                        <span class="icon"><i class='bx bx-unlink'></i></span>
                        <span class="menu-title">Disable Menu</span>
                    </a>
                </li>

                <li class="nav-item-title">
                    Support
                </li>

                <li class="nav-item">
                    <a href="#" class="nav-link">
                        <span class="icon"><i class='bx bx-file'></i></span>
                        <span class="menu-title">Documentation</span>
                    </a>
                </li>

                <li class="nav-item">
                    <a href="mailto:hello@envytheme.com" class="nav-link">
                        <span class="icon"><i class='bx bx-support'></i></span>
                        <span class="menu-title">Support</span>
                    </a>
                </li>

            </ng-container>
        </ul>
    </div>
</div>
<!-- End Sidemenu Area -->